// biome-ignore assist/source/organizeImports: Temporary app-bar
import { AppBar as MuiAppBar } from '@mui/material';
import { css } from '@emotion/react';
import { alpha, styled as muiStyled } from '@mui/material/styles';
import { SecondaryButton } from '@ui/buttons';
import styled from '@emotion/styled';
import { rem } from '@utils';

const AppBar = muiStyled(MuiAppBar)(({ theme }) => ({
  backgroundColor: 'transparent',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.08)}`,
  gridArea: 'a'
}));

const BrandTitle = styled.h3(
  () => css`
    cursor: pointer;
  `
);

const NavButton = styled(SecondaryButton)<{ active?: boolean }>(
  ({ active, theme }) => css`
    border-radius: ${rem(0)};
    border-bottom: ${rem(2)} solid;
    border-bottom-color: ${active ? theme.palette.primary.main : 'transparent'};
    color: ${active ? theme.palette.primary.main : theme.palette.common.black};
  `
);

export default {
  AppBar,
  BrandTitle,
  NavButton
};
